import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FamiliarCreatePageRoutingModule } from './familiar-create-routing.module';

import { FamiliarCreatePage } from './familiar-create.page';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    PipesModule,
    FamiliarCreatePageRoutingModule
  ],
  declarations: [FamiliarCreatePage]
})
export class FamiliarCreatePageModule {}
